import { AmountType } from '@shared/cards-types';

export const creditShared = {
    layout: {
        productInfo: {
            showBalanceAndOutstandingAmount: true,
        },
    },
    functions: {
        payUp: {
            suggestionAmounts: [
                AmountType.MINIMAL_MONTHLY_AMOUNT,
                AmountType.OVER_DUE_AMOUNT,
                AmountType.REMAINING_OUTSTANDING_AMOUNT,
            ],
            validAccounts: {
                currentAndSavingsAccounts: true,
                domesticOrOwnTransferAllowed: true,
            },
        },
    },
    menu: {
        newTransfer: {
            enabled: true,
        },
        supplementary: {
            enabled: true,
        },
    },
    reservations: {
        description: true,
        info: true,
        status: true,
        expirationDate: true,
        type: true,
    },
    settings: {
        productWhitelist: ['MAIN'],
    },
    supplementary: {
        enabled: true,
    },
    showAuthorizedAsSubCard: true,
};
